import { ContentSubmissionStage } from '../types/content-submissions';

export const instagramRegex = /^(?:https?:\/\/)?(?:www\.)?instagram\.com\/(?:p|reel|tv)\/[\w.-]+/;
export const youtubeRegex =
  /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:embed\/|v\/|watch\?v=|shorts\/)|youtu\.be\/)([\w-]{11})(?:\S+)?$/;
export const tiktokPostRegex =
  /^(?:https?:\/\/)?(?:www\.)?(?:(?:vm|vt)\.tiktok\.com\/[\w\d]+|tiktok\.com\/(?:(?:v\/(\d+))|@[\w.-]+\/(?:video|photo)\/(\d+)|t\/[\w\d]+))(?:[/?].*)?$/;
export const instagramUsernameRegex = /^[\w.]+$/;

// Constants for media upload on content submission
export const MAX_IMAGES = 20;
export const MAX_IMAGE_SIZE = 5 * 1024 * 1024; // 5MB for images
export const MAX_VIDEO_SIZE = 150 * 1024 * 1024; // 150MB for videos

export const sidebarLinks: {
  logo: string;
  label: string;
  href: string;
  disabled: boolean;
}[] = [
  { logo: '📊️', label: 'Dashboard', href: '/dashboard', disabled: false },
  { logo: '📷', label: 'My Posts', href: '/dashboard/my-posts', disabled: false },
  { logo: '📂', label: 'Resources', href: '/dashboard/resources', disabled: false },
  { logo: '💿', label: 'Submissions', href: '/dashboard/submissions', disabled: false },
  { logo: '💳', label: 'Payment History ', href: '/dashboard/payment-history', disabled: false },
  { logo: '🤳', label: 'Usage Rights ', href: '/dashboard/usage-rights', disabled: false },
];

export const TABS = {
  PENDING: {
    value: 'pending' as ContentSubmissionStage,
    label: 'Pending Review',
    emptyState: {
      title: 'No Submissions Yet!',
      description: 'Upload your content here to get feedback and approval from the brand.',
      showUploadButton: true,
    },
  },
  CHANGES_REQUESTED: {
    value: 'changesRequested' as ContentSubmissionStage,
    label: 'Changes Requested',
    emptyState: {
      title: 'No Changes Requested!',
      description: 'Once the brand reviews your content, the requested changes will reflect here.',
      showUploadButton: false,
    },
  },
  APPROVED: {
    value: 'approved' as ContentSubmissionStage,
    label: 'Approved',
    emptyState: {
      title: 'No Content Approved Yet!',
      description: 'Once the brand approves your content, it will show up here.',
      showUploadButton: false,
    },
  },
};

export const ugcLinks: {
  logo: string;
  label: string;
  href: string;
  disabled: boolean;
}[] = [
  { logo: '📊️', label: 'Dashboard', href: '/dashboard', disabled: false },
  { logo: '💿', label: 'Submissions', href: '/dashboard/submissions', disabled: false },
  { logo: '💳', label: 'Payment History ', href: '/dashboard/payment-history', disabled: false },
];

export const REQUEST_PRODUCT_MODAL_TABS_VALUES = {
  AVAILABLE_PRODUCTS: 'availableProducts',
  REQUESTED_PRODUCTS: 'requestedProducts',
};

export const REQUEST_PRODUCT_MODAL_TABS = [
  { value: REQUEST_PRODUCT_MODAL_TABS_VALUES.AVAILABLE_PRODUCTS, label: 'Available Products' },
  { value: REQUEST_PRODUCT_MODAL_TABS_VALUES.REQUESTED_PRODUCTS, label: 'Requested Products' },
];
